import { Box } from '@mui/material';
import { ReactElement } from 'react';

import ChangePasswordCard from './components/ChangePasswordCard';
import SecuritySettingsCard from './components/SecuritySettingsCard';
// import UserDetailsForm from '../profile/components/UserDetailsForm';

const SecurityDetailPage = (): ReactElement => (
    <Box className="security-page">
        <ChangePasswordCard />
        <SecuritySettingsCard />
    </Box>
);

export default SecurityDetailPage;
